import internalServerErrorImg from '@assets/status-pages/internal_server_error.webp';
import { useLingui } from '@lingui/react/macro';

import { Header, NoDataServerErrorWrapper, SubHeader, Text } from './styled.tsx';

const NoDataServerError = () => {
    const { t } = useLingui();

    return (
        <NoDataServerErrorWrapper>
            <img src={internalServerErrorImg} alt={t`server error`} />
            <Header>500</Header>
            <SubHeader>{t`Internal Server Error!`}</SubHeader>
            <Text>{t`Something went wrong. We’re working to fix it.`}</Text>
        </NoDataServerErrorWrapper>
    );
};

export default NoDataServerError;
